// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Baloo_2_f8b22a', '__Baloo_2_Fallback_f8b22a'","fontStyle":"normal"},"className":"__className_f8b22a","variable":"__variable_f8b22a"};